import React from 'react';

import { useRecoilValue } from 'recoil';

import { userDispensariesAtom } from 'src/app/state/user-dispensaries';

import { QueryBuilderMultiSelect } from './shared/query-builder-multi-select';

// the `value` should always be lowercase to align with snowflake values
export const paymentOptions = [
  { value: 'cash', label: 'Cash' },
  { value: 'debit', label: 'Debit' },
  { value: 'credit', label: 'Credit' },
  { value: 'check', label: 'Check' },
  { value: 'dutchiepay', label: 'Pay by bank' },
  { value: 'giftcard', label: 'Gift card' },
];

type PaymentOptionDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type PaymentOption = {
  id: string;
  name: string;
};

export function PaymentOptionDropdown({ onChange, values, disabled = false }: PaymentOptionDropdownProps) {
  const userDispensaries = useRecoilValue(userDispensariesAtom);
  const canUseDutchiePay = userDispensaries.locProfile.HasDutchiePay;

  const filteredPaymentOptions = canUseDutchiePay
    ? paymentOptions
    : paymentOptions.filter((option) => option.value !== 'dutchiepay');

  const transformedPaymentOptions: PaymentOption[] = filteredPaymentOptions.map((option) => ({
    id: option.value,
    name: option.label,
  }));

  return (
    <QueryBuilderMultiSelect<PaymentOption>
      automationIdPrefix='payment-options'
      defaultLabel='Select payment options'
      disabled={disabled}
      idKey='id'
      items={transformedPaymentOptions}
      loading={false}
      nameKey='name'
      values={values}
      onChange={onChange}
    />
  );
}
